export default __webpack_public_path__ + "static/char-thumb-40-d9ce825e70b62d8194238b501fda02b6.webp";